import React, { useState } from 'react';

const items = [
  {
    q: 'A consulta inicial é gratuita?',
    a: 'Sim. Oferecemos avaliação clínica inicial sem custo, sem compromisso. Você sai com o diagnóstico e um plano de tratamento detalhado, incluindo valores e opções de pagamento.',
  },
  {
    q: 'Vocês atendem convênio?',
    a: 'Não atendemos planos odontológicos. Nosso atendimento é particular, com preços que cabem no seu bolso e opções de pagamento facilitadas.',
  },
  {
    q: 'Como agendar uma consulta?',
    a: 'Pelo WhatsApp (21) 97898-2711 ou pelo formulário de contato nesta página. Respondemos em até 2 horas em dias úteis.',
  },
  {
    q: 'O tratamento de implante é demorado?',
    a: 'Depende do caso. Em implantes convencionais, o processo leva entre 4 e 8 meses. Casos com carga imediata podem ser resolvidos em menos tempo. Dr. Marcio avalia cada situação individualmente.',
  },
  {
    q: 'Vocês atendem crianças?',
    a: 'Sim. Atendemos crianças a partir dos 6 anos, com abordagem tranquila e acolhedora para deixar a consulta mais leve.',
  },
  {
    q: 'Quais formas de pagamento vocês aceitam?',
    a: 'Aceitamos cartões de crédito, débito, Pix e dinheiro. No cartão de crédito, parcelamos em até 10x sem juros.',
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(null);

  return (
    <>
      <div className="divider" id="faq">
        <span><span className="dot"></span> 08 / FAQ</span>
        <span>Dúvidas frequentes</span>
      </div>

      <section className="faq">
        <div className="faq-inner">
          <div className="faq-left">
            <h2 className="display">
              Perguntas<br />que todo<br /><em>mundo</em><br />faz.
            </h2>
          </div>

          <div className="faq-list">
            {items.map((item, i) => (
              <div
                key={i}
                className={`faq-item${open === i ? ' open' : ''}`}
              >
                <div
                  className="faq-question"
                  onClick={() => setOpen(open === i ? null : i)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => e.key === 'Enter' && setOpen(open === i ? null : i)}
                >
                  <span>{item.q}</span>
                  <span className="faq-plus"></span>
                </div>
                <div className="faq-answer">{item.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
